<div *ngIf="newDocument as nd">
  <div class="grid" *ngIf="showDocumentDetails">
    <div class="col-6" *ngIf="showDepartments">
      <app-departmentselector labelKey="Поставщик" [parentCompany]="nd.DOCMANCLIID" [selectedID]="nd.DOCMANDEPID" disabled="true"></app-departmentselector>
    </div>
    <div class="col-6" *ngIf="showDepartments">
      <app-departmentselector labelKey="Получатель" [parentCompany]="nd.DOCCLIENTSID" [selectedID]="nd.DOCCLIDEPID" disabled="true"></app-departmentselector>
    </div>
    <div class="field col-6">
      <label>Примечание при передаче</label>
      <input type="text" pInputText [(ngModel)]="nd.DOCNOTE1" readonly disabled />
    </div>
    <div class="field col-6">
      <label>Примечание при приеме</label>
      <input type="text" pInputText [(ngModel)]="nd.DOCNOTE2" readonly disabled />
    </div>
  </div>

  <!-- Capture row -- only when the caller asked for it (allowAdd). The generated-row
       tables that already use this component render exactly as before. -->
  <div class="grid formgrid align-items-end mb-2" *ngIf="allowAdd">
    <div class="field col-12 md:col-7">
      <label class="block">Добавить товар</label>
      <app-productselector [showLabel]="false" (selectedProduct)="onPendingProductSelected($event)"></app-productselector>
    </div>
    <div class="field col-6 md:col-2">
      <label class="block">Количество</label>
      <p-inputNumber [(ngModel)]="pendingQty" [min]="1" [showButtons]="true" styleClass="w-full"></p-inputNumber>
    </div>
    <div class="field col-6 md:col-3">
      <p-button label="Добавить" icon="pi pi-plus" (onClick)="onAddProduct()" [disabled]="!canAdd"
                pTooltip="Добавить выбранный товар в документ" tooltipPosition="top"></p-button>
      <i class="pi pi-spin pi-spinner ml-2" *ngIf="addingPrice" pTooltip="Загружается цена"></i>
    </div>
  </div>

  <div class="grid" *ngIf="nd.items as items">
    <p-table #docItemTable
             id="docItemTable"
             [value]="items"
             selectionMode="multiple"
             [(selection)]="selection"
             [rowHover]="true"
             [resizableColumns]="true"
             styleClass="p-datatable p-datatable-gridlines p-datatable-striped"
             [ngStyle]="{'width': '100%'}"
             >

      <ng-template pTemplate="caption" *ngIf="items.length > 20">
        <div class="grid formgrid justify-content-end">
          <p-button label="Выбрать все" icon="pi pi-check-circle" (onClick)="onSelectAll($event)" class="mt-2 mr-2" [disabled]="items.length < 1"
                    pTooltip="Выбрать все строки" tooltipPosition="top"></p-button>
          <p-button label="Отменить" icon="pi pi-circle-off" (onClick)="onUnSelectAll($event)" class="mt-2 mr-2" styleClass="p-button-warn" [disabled]="selection.length < 1"
                    pTooltip="Отменить выбор строк" tooltipPosition="top"></p-button>
          <p-button label="Удалить строки ({{selection.length}})" icon="pi pi-trash" (onClick)="onRemoveRow($event)" class="mt-2 mr-2" styleClass="p-button-danger" [disabled]="selection.length < 1"
                    pTooltip="Убрать выбранную строку" tooltipPosition="top"></p-button>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="PRODCODE" style="width:30% !important" pResizableColumn>Код товара <p-sortIcon field="PRODCODE"></p-sortIcon></th>
          <th pSortableColumn="DOCITEMPRODNAME" style="width: auto !important" pResizableColumn>Название товара <p-sortIcon field="DOCITEMPRODNAME"></p-sortIcon></th>
          <th pSortableColumn="DOCITEMTEXT1" style="width: 6rem !important" pResizableColumn *ngIf="showNote">{{docNote1Header}} <p-sortIcon field="DOCITEMTEXT1"></p-sortIcon></th>
          <th pSortableColumn="DOCITEMTEXT2" style="width: 6rem !important" pResizableColumn *ngIf="showNote2">{{docNote2Header}} <p-sortIcon field="DOCITEMTEXT2"></p-sortIcon></th>
          <th pSortableColumn="DOCITEMQTY" style="width: 6rem !important" pResizableColumn>Количество <p-sortIcon field="DOCITEMQTY"></p-sortIcon></th>
          <th pSortableColumn="DOCITEMSHIPPED" style="width: 6rem !important" pResizableColumn *ngIf="showShipped">Отгружено <p-sortIcon field="DOCITEMSHIPPED"></p-sortIcon></th>
          <th pSortableColumn="prodInfo.PRODSTOCK" style="width: 6rem !important" pResizableColumn *ngIf="showStock">Склад <p-sortIcon field="prodInfo.PRODSTOCK"></p-sortIcon></th>
          <th pSortableColumn="prodInfo.PRODRESERVE" style="width: 6rem !important" pResizableColumn *ngIf="showReserve">Резерв <p-sortIcon field="prodInfo.PRODRESERVE"></p-sortIcon></th>
          <th pSortableColumn="prodInfo.PRODSOLD" style="width: 6rem !important" pResizableColumn *ngIf="showSold">Продано <p-sortIcon field="prodInfo.PRODSOLD"></p-sortIcon></th>
          <th pSortableColumn="DISCOUNT" style="width: 7rem !important" pResizableColumn *ngIf="showDiscount">Скидка <p-sortIcon field="DISCOUNT"></p-sortIcon></th>
          <th pSortableColumn="U4ETKA" style="width: 8rem !important" pResizableColumn *ngIf="showU4etka">{{U4ETKALabel}}<p-sortIcon field="U4ETKA"></p-sortIcon></th>
          <th pSortableColumn="DOCITEMVPRICE" style="width: 8rem !important" pResizableColumn *ngIf="showVprice">Цена $ <p-sortIcon field="DOCITEMVPRICE"></p-sortIcon></th>
          <th pSortableColumn="DOCITEMPRICE" style="width: 9rem !important" pResizableColumn *ngIf="showPrice">Цена <p-sortIcon field="DOCITEMPRICE"></p-sortIcon></th>
          <th pSortableColumn="DOCITEMSUM" style="width: 9rem !important" pResizableColumn *ngIf="showPrice">Сумма <p-sortIcon field="DOCITEMSUM"></p-sortIcon></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-docItem>
        <tr [pSelectableRow]="docItem">
          <td style="max-width: 150px !important; ">{{docItem.PRODCODE}}</td>

          <td style="max-width: 350px !important; ">{{docItem.DOCITEMPRODNAME}}</td>

          <td style="width: 6rem !important; " *ngIf="showNote">{{docItem.DOCITEMTEXT1}}</td>
          <td style="width: 6rem !important; " *ngIf="showNote2">{{docItem.DOCITEMTEXT2}}</td>
          <td style="width: 6rem !important; text-align: right">
            <p-inputNumber *ngIf="allowAdd; else qtyReadOnly" [(ngModel)]="docItem.DOCITEMQTY" [min]="0"
                           (onInput)="recalcRowSum(docItem)" (onBlur)="recalcRowSum(docItem)"
                           (keydown)="$event.stopPropagation()"
                           styleClass="w-full" inputStyleClass="text-right"></p-inputNumber>
            <ng-template #qtyReadOnly>{{docItem.DOCITEMQTY | number:'1.0-2'}}</ng-template>
          </td>
          <td style="width: 6rem !important; text-align: right; background-color: ghostwhite" *ngIf="showShipped"><span *ngIf="docItem.prodInfo as pi else waiting">{{docItem.DOCITEMSHIPPED | number:'1.0-2'}}</span></td>
          <td style="width: 6rem !important; text-align: right; background-color: ghostwhite" *ngIf="showStock"><span *ngIf="docItem.prodInfo as pi else waiting">{{pi.PRODSTOCK | number:'1.0-2' }}</span></td>
          <td style="width: 6rem !important; text-align: right; background-color: ghostwhite" *ngIf="showReserve"><span *ngIf="docItem.prodInfo as pi else waiting">{{pi.PRODRESERVE | number:'1.0-2' }}</span></td>
          <td style="width: 6rem !important; text-align: right; background-color: ghostwhite" *ngIf="showSold">
            <span *ngIf="docItem.prodInfo as pi else waiting">{{pi.PRODSOLD | number:'1.0-2' }}</span>
            <ng-template #waiting><span>---</span></ng-template>
          </td>
          <td style="width: 7rem !important; overflow: visible !important; text-align: right" *ngIf="showDiscount">{{docItem.DISCOUNT | number:'1.1-1'}}%</td>
          <td style="width: 8rem !important; text-align: right" *ngIf="showU4etka">{{docItem.U4ETKA | number:'1.2-2'}}</td>
          <td style="width: 8rem !important; text-align: right" *ngIf="showVprice">{{docItem.DOCITEMVPRICE | number:'1.2-2'}}</td>
          <td style="width: 9rem !important; text-align: right" *ngIf="showPrice">
            <p-inputNumber *ngIf="allowAdd; else priceReadOnly" [(ngModel)]="docItem.DOCITEMPRICE"
                           [min]="0" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2"
                           (onInput)="recalcRowSum(docItem)" (onBlur)="recalcRowSum(docItem)"
                           (keydown)="$event.stopPropagation()"
                           styleClass="w-full" inputStyleClass="text-right"></p-inputNumber>
            <ng-template #priceReadOnly>{{docItem.DOCITEMPRICE | number:'1.2-2'}}</ng-template>
          </td>
          <td style="width: 9rem !important; text-align: right; background-color: ghostwhite" *ngIf="showPrice">{{docItem.DOCITEMSUM | number:'1.2-2' }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="summary">
        <div class="grid formgrid justify-content-end">
          <p-button label="Выбрать все" icon="pi pi-check-circle" (onClick)="onSelectAll($event)" class="mt-2 mr-2" [disabled]="items.length < 1"
                    pTooltip="Выбрать все строки" tooltipPosition="top"></p-button>
          <p-button label="Отменить" icon="pi pi-circle-off" (onClick)="onUnSelectAll($event)" class="mt-2 mr-2" styleClass="p-button-warn" [disabled]="selection.length < 1"
                    pTooltip="Отменить выбор строк" tooltipPosition="top"></p-button>
          <p-button label="Удалить строки ({{selection.length}})" icon="pi pi-trash" (onClick)="onRemoveRow($event)" class="mt-2 mr-2" styleClass="p-button-danger" [disabled]="selection.length < 1"
                    pTooltip="Убрать выбранную строку" tooltipPosition="top"></p-button>
        </div>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="13">Нет содержимого</td>
        </tr>
      </ng-template>

      <ng-template pTemplate="footer" *ngIf="showVprice || showPrice">
        <tr>
          <td [attr.colspan]="footerLeadColspan" style="text-align: right; font-weight: bold;">Итого:</td>
          <td style="width: 8rem !important; text-align: right; font-weight: bold;" *ngIf="showVprice">{{totalValueSum | number:'1.2-2'}}</td>
          <td style="width: 9rem !important;" *ngIf="showPrice"></td>
          <td style="width: 9rem !important; text-align: right; font-weight: bold; background-color: ghostwhite" *ngIf="showPrice">{{totalDocumentSum | number:'1.2-2'}}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
